<template>
  <div>
  <section class='file-input'>
     <span v-if="files.length == 1">{{ files[0].name }}</span>
     <vue-upload-component
      class="file-select"
      ref="upload"
      v-model="files"
      :post-action="$store.functions.charity.uploadAgreement(charityId)"
      :chunk-enabled="true"
      :chunk="chunkSettings"
      :accept="accept"
      :extensions="extensions"
      :headers="headers"
      @input-file="checkUpload"
      >
      Select File
    </vue-upload-component>
  </section>
  <span v-if="errors.extension" class="error-message file-error">{{ errors.extension }}</span>
  <section class="upload">
    <div class="field buttons left">
      <input type="submit" class="btn" :value="isSubmitting ? 'Uploading...' : 'Upload'" @click="submit"
        :disabled="!files || files.length == 0 || isSubmitting">
    </div>
  </section>
</div>
</template>

<script>
import VueUploadComponent from 'vue-upload-component'
import auth from '@/auth'

export default {
  name: 'CharityUploadAgreement',
  props: ['charityId', 'uploadOnSubmit'],
  data () {
    return {
      data: {},
      files: [],
      accept: '',
      extensions: 'pdf, txt, doc, docx',
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('access_token')
      },
      chunkSettings: {
        action: this.$store.functions.charity.uploadAgreementChunked(this.charityId),
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('access_token')
        },
        minSize: 2097152,
        maxActive: 1,
        maxRetries: 5,
        startBody: {},
        finishBody: {
          user: auth.user.email
        }
      },
      isSubmitting: false,
      errors: {},
      uploadId: null,
      user: auth.user,
    }
  },
  mounted () {
  },
  methods: {
    submit () {
      if (this.uploadOnSubmit) this.upload(this.charityId)
      else this.$emit('addFile', { 'file': this.files[0] })
    },
    upload () {
      this.files[0].data['user'] = this.user.email
      this.chunkSettings.startBody.fileName = this.files[0].name
      this.isSubmitting = true
      this.$refs.upload.active = true
    },
    checkUpload () {
      this.errors = {}
      if (this.files.length > 0 &&
        this.files[0].error === 'extension') {
        this.errors = {
          'extension': 'Invalid File Type. File extension must be .pdf, .txt, .doc, or .docx'
        }
        this.isSubmitting = false
      }
      if (this.files.length > 0 && this.files[0].success &&
        typeof this.files[0].response === 'object' &&
        this.files[0].response.uploaded === true) {
        this.isSubmitting = false
        this.$emit('refresh')
      }
    },
    updatePost (charityId = null) {
      this.files[0].postAction = this.$store.functions.charity.uploadAgreement(charityId !== null ? charityId : this.charityId)
      this.$refs.upload.chunkOptions.action = this.$store.functions.charity.uploadAgreementChunked(charityId !== null ? charityId : this.charityId)
    }
  },
  components: {
    VueUploadComponent
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/variables";

.file-error {
  margin-left: 0;
}
.file-input {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.file-select {
  cursor:pointer;
  color:$link-color;
}
.file-select:hover {
  color:$dark-purple;
}
.upload {
  margin-top: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Charity/CharityUploadAgreement.vue